import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Input } from 'ui-components/components/input';
import { MessageDescriptorPropType } from '../../../prop-types/intl';
import { contains } from '../../../filters/operators/string';

import baseStyle from '../../style.module.less';
import style from './filter-input.module.less';

const FilterInput = ({ id, filters, updateFilter, labelMessage }) => {
  const { value = [] } = filters.find((filter) => filter.id === id) || {};

  const onChange = useCallback(
    (val) => {
      const valueArray = val.split(';');
      updateFilter(id, valueArray, contains);
    },
    [updateFilter, id],
  );

  return (
    <span className={baseStyle.filterInput}>
      <label className={baseStyle.filterLabel}>
        <FormattedMessage {...labelMessage} />
      </label>
      <Input className={style['filter-text-input']} data-testid={`${id}-advanced-search`} onChange={onChange} value={value.join(';')} />
    </span>
  );
};

FilterInput.propTypes = {
  id: PropTypes.string.isRequired,
  filters: PropTypes.array.isRequired,
  updateFilter: PropTypes.func.isRequired,
  labelMessage: MessageDescriptorPropType.isRequired,
};

export default FilterInput;
